var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpdateProfile({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 12,
    viewBox: "0 0 11 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.1579 12C0.839475 12 0.56679 11.8824 0.339843 11.6472C0.112896 11.412 -0.000384982 11.1296 9.82933e-07 10.8V1.2C9.82933e-07 0.870001 0.113475 0.587401 0.340422 0.352201C0.567369 0.117001 0.83986 -0.000398981 1.1579 1.01868e-06H5.78947L9.26316 3.6V5.46L4.63158 10.245V12H1.1579ZM5.78947 12V10.725L8.77105 7.62L10.0158 8.88L7.01974 12H5.78947ZM10.4355 8.46L9.20526 7.185L9.61053 6.765C9.72632 6.645 9.86623 6.585 10.0303 6.585C10.1943 6.585 10.3294 6.645 10.4355 6.765L10.8408 7.2C10.9469 7.32 11 7.4626 11 7.6278C11 7.793 10.9469 7.9304 10.8408 8.04L10.4355 8.46ZM5.21053 4.2H8.10526L5.21053 1.2V4.2Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpdateProfile);
export default __webpack_public_path__ + "static/media/UpdateProfile.ed7a4eb018771d4a2836228639dafd88.svg";
export { ForwardRef as ReactComponent };